module.exports = __webpack_public_path__ + "static/img/icon-upload-green.417739a3.svg";